<template>
    <div class="app-block bg-alabaster border border-alto shadow zone-etape" v-if="!displayOffers">
        <div class="text-right titre-num-etape">Étape <span class="badge badge-etape">{{ step }}</span></div>
        <div v-if="!statusSelected && !situationSelected">
            <h3 class="titre-etape text-center">Sélectionnez <strong class="text-primary">votre statut</strong></h3>
            <div class="row row-center">
                <div v-for="(stat, index) in status" class="form-group col-12 col-md-auto text-center" >
                    <span v-if="(index ==='ret')" class="app-badge app-badge-bordered" v-on:click="validEtap2(defaultretraite);validEtap1(index); step+=1">
                        {{ stat }}
                    </span>
                    <span v-else class="app-badge app-badge-bordered" v-on:click="validEtap1(index)">
                        {{ stat }}
                    </span>
                </div>
            </div>

        </div>
        <div v-if="statusSelected && !situationSelected">
            <h3 class="titre-etape text-center">Sélectionnez <strong class="text-primary">votre situation familiale</strong></h3>
            <div class="row row-center">
                <div v-for="(situation, index) in situations" class="form-group col-12 col-md-auto text-center" >
                    <span  class="app-badge app-badge-bordered" v-on:click="validEtap2(index)">
                        {{ situation }}
                    </span>
                </div>
            </div>
        </div>
        <div v-if="statusSelected && situationSelected">
            <h3 class="titre-etape text-center">Sélectionnez <strong class="text-primary">vos besoins</strong></h3>
            <div class="row row-center" style="border-left: 10px solid #2688ae;">
                <div v-for="(need, index) in needs" class="form-group col-12 col-md-auto text-center" >
                    <div
                        class="form-check form-check-flex"
                        v-if="
                            (['deces', 'enfants'].includes(index)) ||
                            (index ==='horsmetro' && ['res', 'civ', 'ret', 'pom'].includes(statusSelected) === false) ||
                            (index === 'reserves' && statusSelected === 'res') ||
                            (index === 'accident' && ['res', 'civ', 'ret','mil','cvd','pom','pol'].includes(statusSelected) === true) ||
                            (index === 'revenus' && statusSelected !=='ret')
                        ">

                        <input class="form-check-input" type="checkbox" :id="index" :value="need" v-on:click="addNeeds(index)" v-bind:class="'etape-button-enable'+[needSelected.includes(index) ? '-active' : '']">
                        <label class="getoffer-check-label" :for="index">
                            {{ need }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="needSelected.length > 0">
            <div class="app-wrapper app-wrapper-large my-3 my-md-4">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 text-center">
                            <a href="#" null="" class="app-button app-button-primary " id="bt-filtrer" v-on:click="getOffers">
                                <span class="app-button-text">Découvrir les offres</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else >
        <h3 class="titre-etape pt-3">Vos offres <strong class="text-primary">de prévoyance</strong></h3>
        <div v-if="offers.length > 1" class="app-wrapper mb-2 my-mb-4">
            <div class="container-fluid">
                <div class="row">
                    <offre-component v-for="(offer, index) in offers" :offre="offer" :key="index"></offre-component>
                </div>
            </div>
        </div>
        <div v-if="offers.length > 1" class="etape-recap">
            <b>Votre statut :</b>
            {{ status[statusSelected] }}<br>
            <b>Votre situation familiale :</b>
            {{ situations[situationSelected] }} <br>
            <b>Vos offres personnalisées :</b> <span v-for="(need, index) in needSelected">{{ needs[need] }}<span v-if="index < needSelected.length -1 ">, </span></span>
            <br><button v-on:click="change" class="btn btn-primary mt-4">Modifier mes critères</button>
        </div>
    </div>
</template>

<script>
import OffreComponent from "./OffreComponent";
export default {
    name: "EtapesComponent",
    components: {OffreComponent},
    data() {
        return {
            step: 1,
            status: {
                "mil": "Militaire",
                "cvd": "Civil défense",
                "pol": "Police Nationale",
                "pom": "Pompier pro",
                "res": "Réserviste",
                "civ": "Civil",
                "ret": "Retraité"
            },
            statusSelected: null,
            situations: {
                "cel": "Célibataire",
                "fam": "Famille"
            },
            situationSelected: null,
            needs: {
                "deces": "Me protéger en cas de décès / Invalidité",
                "enfants": "Protéger mes enfants",
                "revenus": "Me protéger de la perte de revenu",
                "horsmetro": "Me protéger en affectation hors métropole",
                "accident": "Me protéger des accidents de la vie privée",
                "reserves": "Me protéger en période de réserve"
            },
            defaultretraite : 'fam',
            needSelected: [],
            displayOffers: false,
            offers: null
        }
    },
    methods: {
        clearSelection() {
            this.offers = null
            this.statusSelected = null
            this.situationSelected = null
            this.needSelected = []
        },
        validEtap1(value) {
            this.statusSelected = value
            this.step = 2
        },
        validEtap2(value) {
            this.situationSelected = value;
            this.step = 3
        },
        addNeeds(value) {
            let indice = this.needSelected.indexOf(value)
            if (indice < 0) {
                this.needSelected.push(value)
            } else {
                this.needSelected.splice(indice, 1)
            }
        },
        getOffers() {
            axios.get('/api-prevoyance', {
                params: {
                    status: this.statusSelected,
                    situation: this.situationSelected,
                    needs: this.needSelected
                }
            }).then(response => {
                this.offers = response.data
                this.displayOffers = true
                 var offers_list = this.offers;
                if(offers_list.length < 2){
                    window.location.href = offers_list[0].url;
                }
            }).catch(error=> {
                console.log(error)
            });
        },
        change() {
            this.clearSelection()
            this.displayOffers = false
            this.step = 1
            window.scrollTo(0, 0)
        }
    }

}
</script>

<style scoped>

</style>
